import { Translation } from '@cds/betting-offer';

export function translationToStr(translation: Translation): string {
    return translation.short || translation.value;
}
